const en = {
  generics: {
    DragHere: 'Drag the file here',
    orClick: 'or click on the button',
  },
  auth: {},
}
export default en
